import { JobTitle } from './job-title.model';

export class HoursCalculator {
    FourHoursStaff ?: number;
    EightHoursStaff?: number;
    TenHoursStaff ?: number;
    TwelveHoursStaff ?: number;
    TotalHours ?: number;
    JobTitle: JobTitle;
    TargetHours ? : number
    BlockId?: number;
}
